<template>
    <div class="contract">
        <div class="card-info-row">
            <div class="card-info avatar">
                    <v-img class="card-avatar" :src="contract.bankLogo" />
                <div class="card-info">
                    <label><b>Banco</b></label>
                    <p>{{ contract.bankName }}</p>
                </div>
            </div>
        </div>
        <div class="card-info-row">
            <div class="card-info">
                <label><b>Prazo</b></label>
                {{ contract.paid }}/{{ contract.term }}
            </div>
            <div class="card-info">
                <label><b>Parcela</b></label>
                {{ contract.installment | fmtMoney }}
            </div>
            <div class="card-info">
                <label><b>Valor</b></label>
                {{ contract.amount | fmtMoney }}
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        contract: {
            type: Object,
            required: true
        },
    }
}
</script>

<style scoped>
    p {
        margin: 0;
    }
    .contract {
        width: 100%;
        display: flex;
        flex-direction: column;
        padding: 15px;
        border-radius: 5px;
        background-color: #0000ff0c;
        gap: 10px;
    }

    .card-info {
        display: flex;
        flex-direction: column;
    }

    .card-info > label {
        font-size: 12px;
        color: var(--gray-color);
    }

    .card-info.avatar {
        flex-direction: row;
        align-items: center;
    }

    .card-info-row {
        display: flex;
        flex-direction: row;
        gap: 20px;
    }

    .card-avatar {
        width: 40px;
        height: 40px;
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 22px;
        font-weight: bold;
        color: var(--white-color);
        margin-right: 10px;
    }

    .card-info span {
        display: flex;
        flex-direction: row;
        align-items: center;
        gap: 5px;
    }
</style>


// WEBPACK FOOTER //
// src/components/Prospection/Contract.vue